import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installCaseDbCsrfFetchInterceptor } from './utils/csrf';

installCaseDbCsrfFetchInterceptor();

const Root = () => {
  const [theme, setTheme] = useState('light');

  const changeTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <App />
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);